import { InjectionToken } from '@angular/core';

export interface AppConfig {
  production: boolean;
  apiHost: string;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
